let apiEndpoint = null
let idpApiEndpoint = null
let useLokalInstallation = null

export const setapiendpoint = (url, urlIdp) => {
  apiEndpoint = url
  idpApiEndpoint = urlIdp
}

export const setlokalinstallation = (lokalinstallation) => {
  useLokalInstallation = lokalinstallation
}

export const getapiendpoint = () => apiEndpoint

export const getIdpApiendpoint = () => idpApiEndpoint

export const getUseLokalInstallation = () => useLokalInstallation
